import * as React from 'react'

import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react'
import { inject, observer } from 'mobx-react'

import FacetButton from '~/client/src/shared/components/Filters/components/FacetButton/FacetButton'
import FilterHandleButton from '~/client/src/shared/components/Filters/components/FilterHandleButton/FilterHandleButton'
import EventsStore from '~/client/src/shared/stores/EventStore/Events.store'
import SuperFilterStore from '~/client/src/shared/stores/ui/SuperFilter.store'

interface IBaseFilter {
  filterStore: SuperFilterStore
  eventsStore?: EventsStore
  className?: string
  captionClassName?: string
  onToggle?: () => void
  shouldRenderRightIcon?: boolean
  hasIndent?: boolean
}

@inject('eventsStore')
@observer
export default class SuperFilterHandleButton extends React.Component<IBaseFilter> {
  private readonly clearPostEventCallback: () => void

  public constructor(props: IBaseFilter) {
    super(props)

    if (!this.store.filter.isInitialized) {
      this.store.setInitialFilterValues()
      this.store.filter.isInitialized = true
    }

    this.clearPostEventCallback = props.eventsStore.addPostEventCallback(
      this.store.onFilterActionRequest,
    )
  }

  public componentWillUnmount() {
    if (this.clearPostEventCallback) {
      this.clearPostEventCallback()
    }
  }

  public onToggle = () => {
    const handler = this.props.onToggle || this.store.toggle
    handler()
  }

  public render() {
    const {
      className,
      children,
      shouldRenderRightIcon,
      hasIndent = true,
    } = this.props
    const { isShown, isHandleButtonActive, handleButtonCaption } = this.store

    if (children) {
      return (
        <div className={`filter-wrapper ${className}`}>
          <FilterHandleButton
            isSelected={isShown}
            isActive={isHandleButtonActive}
            onClick={this.onToggle}
            hasIndent={hasIndent}
          >
            {children}
            {shouldRenderRightIcon && (
              <span className="pr10">
                {this.store.isShown ? (
                  <ChevronUpIcon size={12} />
                ) : (
                  <ChevronDownIcon size={12} />
                )}
              </span>
            )}
          </FilterHandleButton>
        </div>
      )
    }

    return (
      <div className={`filter-wrapper ${className}`}>
        <FacetButton
          label={handleButtonCaption}
          isOpen={isShown}
          isActive={isHandleButtonActive}
          onClick={this.onToggle}
        />
      </div>
    )
  }

  private get store(): SuperFilterStore {
    return this.props.filterStore
  }
}
